import { useId, type InputHTMLAttributes } from 'react';
import { Icon } from './Icon';
import styles from './Checkbox.module.css';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id'> {
  label?: string;
  id?: string;
}

/**
 * Port of components/forms/Checkbox.jsx. The source renders a styled <span>
 * with an onClick handler, which has no keyboard or screen-reader support.
 * This ports it as a real <input type="checkbox"> (appearance: none, styled
 * to match) so focus, space-bar toggling and assistive tech keep working.
 */
export function Checkbox({ label, id, className, ...rest }: CheckboxProps) {
  const generatedId = useId();
  const checkboxId = id ?? generatedId;

  return (
    <label htmlFor={checkboxId} className={[styles.label, className].filter(Boolean).join(' ')}>
      <span className={styles.boxWrapper}>
        <input type="checkbox" id={checkboxId} className={styles.input} {...rest} />
        <Icon name="check" size={12} color="var(--text-on-primary)" strokeWidth={3} className={styles.check} />
      </span>
      {label && <span className={styles.text}>{label}</span>}
    </label>
  );
}
